var map = {
	"./": 67122,
	"./en_US": 71654,
	"./en_US.js": 71654,
	"./index": 67122,
	"./index.js": 67122,
	"./ko_KR": 12412,
	"./ko_KR.js": 12412,
	"./kz_KZ": 62649,
	"./kz_KZ.js": 62649,
	"./mn_MN": 27681,
	"./mn_MN.js": 27681,
	"./ru_RU": 96937,
	"./ru_RU.js": 96937
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89458;
module.exports = webpackAsyncContext;